import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithNProgress from 'app/utils/services/baseQueryWithNProgress';

import type { Package } from '../types/enrichmentTypes';

export const enrichmentApi = createApi({
	reducerPath: 'enrichmentApi',
	baseQuery: baseQueryWithNProgress,
	endpoints: builder => ({
		getEnrichmentPackages: builder.query<Package[], void>({
			query: () => '/enrichment/packages/',
			keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
		}),
		getEnrichmentFieldNames: builder.query<Record<string, string>, void>({
			query: () => '/enrichment/field_names/',
		}),
	}),
});

export const { useGetEnrichmentPackagesQuery, useGetEnrichmentFieldNamesQuery } = enrichmentApi;
